import LyoLogo from '../../../assets/images/NicoLetras2.webp'
import IGLogo from '../../../assets/images/social/instagram-round.webp'
import FBLogo from '../../../assets/images/social/facebook-round.webp'
import WPLogo from '../../../assets/images/social/whatsapp.webp'

import PhoneLogo from '../../../assets/images/mini/phone.webp'
import LocationLogo from '../../../assets/images/mini/location.webp'
import MailLogo from '../../../assets/images/mini/email.webp'
import DG from '../../../assets/datosGenerales.json'
import './style.css';

export default function Footer() {

  return ( 
    <footer className='Footer'>
      <div className='texto'>
        <img className='logo' src={LyoLogo}/>
        <div className='icon-gallery'>
          <a href={DG.linkInstagram} target="_blank" title='Link a Instagram de Nicolini Refrigeración'><img className='icon' src={IGLogo} alt='Instagram'/></a>
          <a href={DG.linkFacebook} target="_blank" title='Link a Facebook de Nicolini Refrigeración'><img className='icon' src={FBLogo} alt='Facebook'/></a>
          <a href={DG.linkWhatsApp} target="_blank" title='Link a WhatsApp de Nicolini Refrigeración'><img className='icon' src={WPLogo} alt='WhatsApp'/></a>
        </div>
      </div>

      <div className='texto1'>
        <a href={"tel:+549"+DG.cel} target="_blank" title='Llamar por telefono'><img className='icon' src={PhoneLogo} alt='Llamar'/>+54 9 {DG.cel}</a>
        <a href={DG.linkMaps} target="_blank" title='Buscar en Google Maps'><img className='icon' src={LocationLogo} alt='Localizar'/>{DG.direccion+", "+DG.localidad}</a>
        <a href={"mailto:"+DG.email} target="_blank" title='Enviar correo electrónico'><img className='icon' src={MailLogo} alt='Enviar correo'/>{DG.email}</a>   
      </div>
    </footer>
  )
}
